import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./routes/App";
import { configureAppStore } from "./store/configureStore";
import "./styles/app.scss";

const store = configureAppStore();
const container = document.getElementById("root");
const root = createRoot(container);

const renderApp = (Component) => {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <Component />
      </BrowserRouter>
    </Provider>
  );
};

renderApp(App);

// ✅ HMR aman di CommonJS
if (module.hot) {
  module.hot.accept("./routes/App", () => {
    const NextApp = require("./routes/App").default;
    renderApp(NextApp);
  });
}
